// extracted by css-extract-rspack-plugin
export default {"peddingCard":"peddingCard-vQvFK9"};